/** Constantes de color para JS — paleta del manual de marca Léora */
export const SF_COLORS = {
  burgundy: '#36151c',
  brown: '#3a2d28',
  terracotta: '#a48374',
  sand: '#ccad8e',
  greige: '#d2c8be',
  beige: '#ede2dc',
  cream: '#f2ede7',
  text: '#3a2d28',
  accent: '#a48374',
  accentGlow: 'rgba(164, 131, 116, 0.35)',
  surface: '#ede2dc',
  background: '#f2ede7',
  cta: '#36151c',
};
